import { EnrichedSwarovskiProductFrontendProductReview, SwarovskiOptikLocaleFrontend } from "@swo/storefront";
import { CommentTranslation } from "./CommentTranslation";

export function getCommentTranslation(
  comment: EnrichedSwarovskiProductFrontendProductReview["comment"],
  locale: SwarovskiOptikLocaleFrontend,
): CommentTranslation {
  const currentLanguageIsoCode = locale.language.isoCode;

  if (currentLanguageIsoCode === comment.languageIsoCode) {
    return { tag: "original-comment-language-matches-current-language", comment: comment.original };
  } else {
    const maybeTranslatedComment = comment.translated?.[currentLanguageIsoCode];

    if (maybeTranslatedComment) {
      return {
        tag: "translated-comment-into-current-language",
        languageIsoCode: currentLanguageIsoCode,
        comment: maybeTranslatedComment,
      };
    } else {
      const maybeTranslatedComment = comment.translated?.["en"];

      if (maybeTranslatedComment) {
        return {
          tag: "translated-comment-into-english",
          languageIsoCode: "en",
          comment: maybeTranslatedComment,
        };
      } else {
        return {
          tag: "no-translated-comment-available",
          comment: comment.original,
        };
      }
    }
  }
}
